// extracted by mini-css-extract-plugin
module.exports = {"bo-item":"bo-item_bo-item__CeCP4","bo-item-logo":"bo-item_bo-item-logo__jlMFB","bo-item-text":"bo-item_bo-item-text__2TNaP","bo-items":"bo-item_bo-items__10HOd"};